import { render, staticRenderFns } from "./purchaseApprovers.vue?vue&type=template&id=00214de5&scoped=true"
import script from "./purchaseApprovers.vue?vue&type=script&lang=js"
export * from "./purchaseApprovers.vue?vue&type=script&lang=js"
import style0 from "./purchaseApprovers.vue?vue&type=style&index=0&id=00214de5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00214de5",
  null
  
)

export default component.exports